import nlp from 'compromise';
import moment from 'moment';
import Container from '../ioc-container';

let defaultConfig = {
  key: 'Default',
  tags: {
    PartialYear: { isA: 'Date' },
    RecordsFlag: { isA: 'Adjective' },
    AverageRequest: { isA: 'Drop' },
    Export: { isA: 'Drop', also: 'Noun' },
    Confirmation: { isA: 'Drop' },
    Cancel: { isA: 'Drop' },
    WasNice: { isA: 'Drop' },
  },
  words: {
    yesterdays: 'Date',
    todays: 'Date',

    Q1: 'PartialYear',
    Q2: 'PartialYear',
    Q3: 'PartialYear',
    Q4: 'PartialYear',
    Qtr1: 'PartialYear',
    Qtr2: 'PartialYear',
    Qtr3: 'PartialYear',
    Qtr4: 'PartialYear',
    Quarter1: 'PartialYear',
    Quarter2: 'PartialYear',
    Quarter3: 'PartialYear',
    Quarter4: 'PartialYear',
    H1: 'PartialYear',
    H2: 'PartialYear',
    Half1: 'PartialYear',
    Half2: 'PartialYear',

    have: 'Common',
    there: 'Common',
    do: 'Common',
    a: 'Common',
    been: 'Common',
    so: 'Common',
    be: 'Common',
    the: 'Common',
    this: 'Common',
    them: 'Common',

    summary: 'Subject',
    budget: 'Subject',

    yes: 'Confirmation',
    sure: 'Confirmation',
    go: 'Confirmation',
    yep: 'Confirmation',
    ok: 'Confirmation',
    yeah: 'Confirmation',

    no: 'Cancel',
    stop: 'Cancel',
    cancel: 'Cancel',
    nah: 'Cancel',
    na: 'Cancel',
    nope: 'Cancel',

    please: 'WasNice',
    thanks: 'WasNice',
    thankyou: 'WasNice',
  },
  patterns: {
    minus: 'Singular',
    'thank you': 'WasNice',

    '(quarter|qtr) (1|2|3|4) #Cardinal?': 'PartialYear',
    '(half) (1|2) #Cardinal?': 'PartialYear',
    '#PartialYear #Cardinal': 'Date',
    '(last|past) #Cardinal (month|months|year|years|day|days|week|weeks)':
      'Date',
    '[past] (month|months|year|years|day|days|week|weeks)': 'Date',

    '(week|weeks|weekly) * [ending (#WeekDay|today|yesterday)]': 'Drop',
    '[weekly] * ending (#WeekDay|today|yesterday)': 'Date',

    '#Subject [#Preposition] #Subject': 'Subject',

    '#Infinitive #Pronoun [!#Conjunction]': 'Noun',
    '[(last|first|an|any)] !#Date': 'SubjectPrefix',

    '#Pronoun #Modal? (ask|help|examples|do|say)': 'NeedsHelp',
    '^(help|examples)': 'NeedsHelp',

    '(daily|monthly|yearly)? average': 'AverageRequest',

    '(export) #Pronoun?': 'Export',
    '[(export)] * #Pronoun$': 'Export',
    '#Pronoun$': 'Drop',
    '#Preposition #Pronoun$': 'Drop',

    '(record|records|list|forms|data) (of|for)': 'RecordsFlag',
    '(record|records|list|forms|data)$': 'RecordsFlag',
    '#Infinitive (record|records|list|forms|data)': 'RecordsFlag',
    '(show|see|list|data) (#Pronoun|#Determiner)?': 'RecordsFlag',

    '!#Adjective [(for|only|where|just|of|by)] !#Date': 'DimensionPrefix',
    '[^(for|only|where|just|of|by)] !#Date': 'DimensionPrefix',
    '[(for|only|where|just|#Comparable)] #Date': 'Drop',

    '[#Verb] in #ApeUnit': 'Noun',
    '#ApeUnit of [#Verb]': 'Noun',

    '#Noun [#Verb] #Noun': 'DimensionPrefix',
    '#Subject [#Verb] #Noun': 'DimensionPrefix',
    '#Noun [#Verb] !#Noun': 'PotentialDimensionPrefix',

    '#QuestionWord .': 'Drop',
    '#Common #Pronoun': 'Drop',
    '#Verb #Pronoun': 'Drop',
    '#Verb #Pronoun (#VerbPhrase|#Determiner)?': 'Drop',
    '#Verb #Pronoun (#Subject)': 'Drop',
    '(#Verb) #Preposition #Date': 'Drop',

    '#Copula . #Adjective?': 'Drop',
    '#Copula . #Determiner?': 'Drop',
    '#VerbPhrase [#Determiner]': 'Drop',
    '#Conjunction #Adjective': 'Drop',
    '#Common': 'Drop',
    '[in] #ApeUnit': 'Drop',
    '#ApeUnit [of]': 'Drop',
    '#Expression': 'Drop',
    '[(#Preposition|#PastTense|#Particle)] #Date+': 'Drop',
    '#PastTense$': 'Drop',
    '#Preposition #Common #Verb': 'Drop',
    '#Noun #Pronoun$': 'Drop',

    '^total for?': 'Drop',
    total$: 'Drop',
    '^did': 'Drop',
    '[done] #Date': 'Drop',
    done$: 'Drop',
  },
  plurals: {
    concrete: 'concrete',
    lightweight: 'lightweight',
    highstrength: 'highstrength',
  },
};

let compoundWords = [
  'time sheet',
  'time table',
  'light weight',
  'high strength',
];
let compoundClosedToOpen = {};
let compoundWordConfig = {
  key: 'CompoundWords',
  patterns: {},
};
compoundWords.forEach(compoundWord => {
  compoundWordConfig.patterns[compoundWord] = 'OpenCompound';
  compoundWordConfig.patterns[compoundWord.replace(' ', '')] = 'ClosedCompound';
  compoundWordConfig.patterns[compoundWord + 's'] = 'OpenCompound';
  compoundWordConfig.patterns[compoundWord.replace(' ', '') + 's'] =
    'ClosedCompound';
  compoundClosedToOpen[compoundWord.replace(' ', '')] = compoundWord;
  compoundClosedToOpen[compoundWord.replace(' ', '') + 's'] = compoundWord;
});

let contractions = {
  operations: 'ops',
};
let contractContractions = Object.keys(contractions).map(key => {
  return {
    regexp: new RegExp(`\\b${key}\\b`, 'g'),
    replace: contractions[key],
  };
});
let expandContractions = Object.keys(contractions).map(key => {
  return {
    regexp: new RegExp(`\\b${contractions[key]}\\b`, 'g'),
    replace: key,
  };
});

export function injectNlpConfig(nlpConfig) {
  let config = { tags: {}, words: {}, patterns: {}, plurals: {} };
  Object.keys(config).forEach(configKey => {
    config[configKey] = Object.assign(
      {},
      nlpConfig[configKey] || {},
      defaultConfig[configKey] || {},
      compoundWordConfig[configKey] || {}
    );
  });

  delete config['words']['for'];
  nlp.plugin(config);
}

export function parseSentence(sentence) {
  let verbose = Container.get('verbose') === true;
  let nlpSentence = createNlpSentence(sentence);
  let subject = extractSubject(nlpSentence);
  let datespan = extractDatespan(nlpSentence);
  let dimension = extractDimension(nlpSentence);
  let unit = extractUnit(nlpSentence);

  let hasDimensionAndMatchesSubject =
    dimension.success && subject.normal == dimension.normal;
  let hasDateSpanAndMatchesSubject =
    datespan.success && subject.normal == datespan.normal;
  let hasUnitAndMatchesSubject = unit.success && subject.normal == unit.normal;
  let needsHelp = nlpSentence.match('#NeedsHelp').terms().length > 0;
  let exportModifier = nlpSentence.match('#Export').terms().length > 0;
  let recordsModifier = nlpSentence.match('#RecordsFlag').terms().length > 0;
  let averageModifier = nlpSentence
    .match('#AverageRequest')
    .normalize()
    .out('text')
    .trim()
    .toLowerCase();
  averageModifier = averageModifier == '' ? null : averageModifier;

  let hasConfirmationModifier =
    nlpSentence.match('#Confirmation').terms().length > 0;
  let hasCancelModifier = nlpSentence.match('#Cancel').terms().length > 0;
  let confirmationModifier = null;
  if (!subject.success && !dimension.success && !datespan.success) {
    if (
      (hasConfirmationModifier || hasCancelModifier) &&
      !(hasConfirmationModifier && hasCancelModifier)
    ) {
      confirmationModifier = hasConfirmationModifier;
    }
  }

  if (
    subject.success == true &&
    (hasDimensionAndMatchesSubject ||
      hasDateSpanAndMatchesSubject ||
      hasUnitAndMatchesSubject ||
      needsHelp)
  ) {
    subject = { success: false };
  }

  let significantTerms = nlpSentence
    .match('!#Drop')
    .match('!#DimensionPrefix')
    .match('!#SubjectPrefix')
    .match('!#RecordsFlag')
    .match('!#Export')
    .out('terms');
  let matchedSignificantTerms = significantTerms.filter(term => {
    return (
      (subject.success && subject.normal.indexOf(term.normal) != -1) ||
      (dimension.success && dimension.normal.indexOf(term.normal) != -1) ||
      (datespan.success && datespan.normal.indexOf(term.normal) != -1) ||
      (unit.success && unit.normal.indexOf(term.normal) != -1)
    );
  });
  let significantTermsString = significantTerms
    .map(term => term.normal)
    .join(' ');
  let matchedSignificantTermsString = matchedSignificantTerms
    .map(term => term.normal)
    .join(' ');
  let confidence =
    matchedSignificantTermsString.length / significantTermsString.length;

  let numberSentence = sentence
    .toLowerCase()
    .replace(' - ', ' minus ')
    .replace(/([a-z])-([a-z])/g, '$1 minus $2')
    .replace(/([\+*/])/g, ' $1 ')
    .replace(/[ ]{2,}/g, ' ');
  let numberParsedSentence = nlp(numberSentence);
  numberParsedSentence
    .match('!#NumberRange')
    .values()
    .toNumber();

  return {
    confidence: confidence,
    sentence: sentence,
    numberParsedSentence: numberParsedSentence.out('text').trim(),
    significantTerms: significantTermsString,
    subject: subject,
    datespan: datespan,
    dimension: dimension,
    unit: unit,
    terms: nlpSentence.out('terms'),
    records: averageModifier ? null : recordsModifier,
    help: needsHelp,
    average: averageModifier,
    export: exportModifier,
    confirmation: confirmationModifier,
  };
  return result;
}

export function createNlpSentence(sentence) {
  let verbose = Container.get('verbose') === true;

  //use nlp to parse the raw sentence
  let nlpSentence = nlp(sentence);

  if (verbose) {
    console.log('initialTerms', nlpSentence.out('terms'));
  }

  nlpSentence
    .match('[#Subject #Pronoun] (#Subject|#Noun)')
    .terms()
    .unTag('Subject')
    .tag('Drop');
  nlpSentence
    .match('#Subject [#Pronoun #Verb]')
    .terms()
    .tag('Drop');

  //untag Subject from key words
  nlpSentence
    .match('#Export')
    .terms()
    .unTag('Subject');
  nlpSentence
    .match('#Confirmation')
    .terms()
    .unTag('Subject');
  nlpSentence
    .match('#Cancel')
    .terms()
    .unTag('Subject');

  //remove the Drop tag from Subject matches that arent average requests
  nlpSentence
    .match('#Subject')
    .match('!#AverageRequest')
    .match('#Drop')
    .terms()
    .unTag('Drop');

  //remove Date tag from ApeUnit's following a Date (to not tag minutes in "hours in minutes" as Date)
  nlpSentence
    .match('#Date [in #ApeUnit]')
    .terms()
    .unTag('Date');
  nlpSentence
    .match('[#Value] in #ApeUnit')
    .terms()
    .tag('Drop');

  //remove DimensionPrefix tag from "Noun Verb Noun" matches where the second Noun is a Date or Pronoun
  nlpSentence
    .match('(#Noun|#Subject) [#Verb] #Date')
    .terms()
    .unTag('DimensionPrefix');
  nlpSentence
    .match('(#Noun|#Subject) [#Verb] #Pronoun')
    .terms()
    .unTag('DimensionPrefix');
  nlpSentence
    .match('!#Subject [#DimensionPrefix] #Subject')
    .terms()
    .unTag('DimensionPrefix');
  nlpSentence
    .match('#ApeUnit [#DimensionPrefix]')
    .terms()
    .unTag('DimensionPrefix');

  //Adjective preceeded by for in our case is much more likely to be a dimension name so remove the tag
  nlpSentence
    .match('for #Adjective')
    .terms()
    .unTag('Drop')
    .unTag('Adjective');

  nlpSentence
    .match('#Common #Pronoun (#Subject)')
    .terms()
    .unTag('Subject')
    .tag('Drop');
  nlpSentence
    .match('#PastTense #Pronoun (#Subject)')
    .terms()
    .unTag('Subject')
    .tag('Drop');
  nlpSentence
    .match('#PresentTense #Pronoun (#Subject)')
    .match('!#Infinitive #Pronoun (#Subject)')
    .terms()
    .unTag('Subject')
    .tag('Drop');

  //don't treat times as dates
  nlpSentence
    .match('#Time')
    .terms()
    .unTag('Date')
    .unTag('Drop');

  //drop an Infinitive that is not a Subject followed by a Subject at the start of a sentence
  // ie in "show hours for person name" drop "show"
  let terms = nlpSentence.terms().list;
  if (terms.length > 1) {
    if (
      terms[0].match('#Infinitive').length == 1 &&
      terms[0].match('#Subject').length == 0 &&
      terms[1].match('#Subject').length == 1
    ) {
      terms[0].tag('Drop');
    }
  }

  //if a PotentialDimensionPrefix is followed by a term without tags then convert to a DimensionPrefix
  terms.forEach((term, index) => {
    if (term.match('#PotentialDimensionPrefix').length == 1) {
      if (terms[index + 1].match('.').out('terms')[0].tags.length == 0) {
        term.tag('DimensionPrefix');
      }
      term.unTag('PotentialDimensionPrefix');
    }
  });

  return nlpSentence;
}

export function extractSubject(nlpSentence) {
  let terms = nlpSentence.match('!#RecordsFlag').out('terms');

  let subjectPrefixIndex = terms.findIndex(term =>
    term.tags.includes('SubjectPrefix')
  );
  terms = terms.filter(
    (term, index) =>
      index > subjectPrefixIndex &&
      !term.tags.includes('AverageRequest') &&
      (term.tags.includes('Subject') || !term.tags.includes('Drop'))
  );
  if (terms.length == 0) {
    return { success: false };
  }

  let subjectRootIndex = terms.findIndex((term, index) =>
    term.tags.includes('Subject')
  );
  if (subjectRootIndex == -1) {
    subjectRootIndex = Math.max(
      0,
      terms.findIndex(
        (term, index) =>
          term.tags.includes('Noun') &&
          !term.tags.includes('Date') &&
          !term.tags.includes('ApeUnit')
      )
    );
  }

  //pin subject root to start of string if only noun found was preceeded by a DimensionPrefix
  if (
    subjectRootIndex > 1 &&
    terms[subjectRootIndex - 1].tags.includes('DimensionPrefix')
  ) {
    subjectRootIndex = 0;
  }

  //if matched a dimension prefix "(DimensionPrefix)for LV101" then exit no subject
  if (
    terms[subjectRootIndex].tags.includes('DimensionPrefix') ||
    terms[subjectRootIndex].tags.length == 0
  ) {
    return { success: false };
  }

  //valid subject terms are Noun, Adjective or Subject words around the root that arent a Date word
  //if the subject root is Singular then the Adjective must also be Comparable. This allows matching
  //"light" in "light weight concrete" but rejecting "last" in "last vehicle inspection"
  let validSubjectTerm = term => {
    //return !term.tags.includes('Drop') && !term.tags.includes('Date') && _extractSubjectHasTag(term.tags, ['Noun', 'Adjective', 'Subject', 'PresentTense']);
    let isValid =
      term.tags.length == 0 ||
      (_extractSubjectHasTag(term.tags, [
        'Noun',
        'Adjective',
        'Subject',
        'PresentTense',
        'Verb',
        'Value',
        'NumberRange',
      ]) &&
        !term.tags.includes('Date') &&
        !term.tags.includes('ApeUnit') &&
        !term.tags.includes('DimensionPrefix') &&
        !term.tags.includes('RecordsFlag'));
    return isValid;
  };

  //look around the subject root to find other words likely to be part of the subject
  let subjectStartIndex = subjectRootIndex;
  while (
    subjectStartIndex > 0 &&
    validSubjectTerm(terms[subjectStartIndex - 1])
  ) {
    subjectStartIndex = subjectStartIndex - 1;
  }
  let subjectEndIndex = subjectRootIndex;
  while (
    subjectEndIndex < terms.length - 1 &&
    validSubjectTerm(terms[subjectEndIndex + 1])
  ) {
    subjectEndIndex = subjectEndIndex + 1;
  }

  //extract subject terms and return as string
  let subjectTerms = [];
  for (let i = subjectStartIndex; i <= subjectEndIndex; i++) {
    subjectTerms.push(terms[i]);
  }

  if (
    subjectTerms.every(
      term => term.tags.includes('Date') || term.tags.includes('ApeUnit')
    )
  ) {
    return { success: false };
  }

  let result = {
    success: true,
    normal: subjectTerms
      .filter(term => term.normal.length > 0)
      .map(term => term.normal)
      .join(' '),
    normalVariants: [],
  };
  if (subjectTerms.some(term => term.tags.includes('OpenCompound'))) {
    let openCompound = subjectTerms
      .filter(term => term.tags.includes('OpenCompound'))
      .map(term => term.normal)
      .join(' ');
    result.normalVariants.push(
      result.normal.replace(openCompound, openCompound.replace(' ', ''))
    );
  }

  if (subjectTerms.some(term => term.tags.includes('ClosedCompound'))) {
    let closedCompounds = subjectTerms
      .filter(term => term.tags.includes('ClosedCompound'))
      .map(term => term.normal);
    closedCompounds.forEach(closedCompound => {
      result.normalVariants.push(
        result.normal.replace(
          closedCompound,
          compoundClosedToOpen[closedCompound]
        )
      );
    });
  }

  if (subjectTerms.some(term => term.tags.includes('Value'))) {
    let normals = [result.normal].concat(result.normalVariants);
    normals.forEach(normal => {
      let parsedNormal = nlp(normal);
      parsedNormal.values().toNumber();
      let normal1 = parsedNormal.out('text');
      result.normalVariants.push(normal1);
      parsedNormal.values().toText();
      let normal2 = parsedNormal.out('text');
      result.normalVariants.push(normal2);
    });
  }

  let contractedNormal = result.normal;
  contractContractions.forEach(
    item =>
      (contractedNormal = contractedNormal.replace(item.regexp, item.replace))
  );
  result.normalVariants.push(contractedNormal);
  let expandedNormal = result.normal;
  expandContractions.forEach(
    item => (expandedNormal = expandedNormal.replace(item.regexp, item.replace))
  );
  result.normalVariants.push(expandedNormal);

  //make sure variants list is unique
  result.normalVariants = result.normalVariants.filter(
    (v, i, a) => a.indexOf(v) === i && v != result.normal
  );

  return result;
}

function _extractSubjectHasTag(tags, searchTags) {
  return searchTags.some(searchTag => tags.includes(searchTag));
}

function _extractSubjectDoesntHaveTags(tags, searchTags) {
  return searchTags.every(searchTag => !tags.includes(searchTag));
}

export function extractDatespan(nlpSentence) {
  let today = Container.get('today-generator')();
  let workingSentence = nlpSentence.clone();
  workingSentence.values().toNumber();

  let relativeWeekDay = 0;
  let weekEnding = workingSentence.match(
    '(week|weeks|weekly) * [(#WeekDay|today|yesterday)]'
  );
  let relative = weekEnding.dates().data();
  let relativeLast = null;
  if (relative.length > 0) {
    let rdate = relative[0].date;
    if (rdate) {
      if (rdate.weekday) {
        relativeWeekDay = rdate.weekday;
      } else if (rdate.named == 'today') {
        relativeWeekDay = moment(today).isoWeekday();
        relativeLast = false;
      } else if (rdate.named == 'yesterday') {
        relativeWeekDay = moment(today)
          .subtract(1, 'day')
          .isoWeekday();
        relativeLast = true;
      }
    }
    weekEnding.delete();
  }

  let dates = workingSentence.dates().data();

  //no native dates found use some heuristics to find our own from the raw terms
  if (dates.length == 0) {
    let terms = workingSentence.out('terms');

    //if there is a single numeric term that looks like a year use that year for the datespan
    if (
      terms.length == 1 &&
      terms[0].tags.includes('NumericValue') &&
      terms[0].tags.includes('Cardinal')
    ) {
      let yearTerm = terms[0];
      let year = new Number(yearTerm.normal).valueOf();
      if (Number.isInteger(year) && year >= 1000 && year <= 9999) {
        dates.push({ normal: yearTerm.normal, date: { year: year } });
      }
    }
  }

  if (dates.length == 0) {
    return _extractDatespanCreateResponse(dates);
  }

  let keyDate = dates[0];

  //if there is more than 1 date match use the terms to find the date mostly likely to be being asked for
  // - using Preposition so match 2010 in the sentence "Was there a form 2020 (Preposition)in 2010"
  // - using non duration dates so match today in the sentence "How many hours today"
  if (dates.length > 1 && relative.length == 0) {
    let terms = workingSentence.out('terms');
    let prepositionPreceededDateTerm = terms.find(
      (term, index) =>
        term.tags.includes('Date') &&
        terms[Math.max(0, index - 1)].tags.includes('Preposition')
    );
    if (prepositionPreceededDateTerm != null) {
      keyDate =
        dates[
          terms
            .filter(term => term.tags.includes('Date'))
            .findIndex(term => term == prepositionPreceededDateTerm)
        ];
    } else {
      let nonDurationDateTerm = terms.find(
        (term, index) =>
          term.tags.includes('Date') && !term.tags.includes('Duration')
      );
      if (nonDurationDateTerm != null) {
        keyDate =
          dates[
            terms
              .filter(term => term.tags.includes('Date'))
              .findIndex(term => term == nonDurationDateTerm)
          ];
      }
    }
  }

  let dateUtterance = keyDate.normal.replace("'", '');
  dateUtterance = dateUtterance.replace('past', 'the last');

  //check for known relative dates
  switch (dateUtterance) {
    case 'today':
    case 'todays':
      return _extractDatespanCreateResponse(dates, moment(today));

    case 'yesterday':
    case 'yesterdays':
      return _extractDatespanCreateResponse(
        dates,
        moment(today).subtract(1, 'days')
      );

    case 'tomorrow':
    case 'tomorrows':
      return _extractDatespanCreateResponse(
        dates,
        moment(today).add(1, 'days')
      );

    case 'week':
    case 'weeks':
    case 'weekly':
    case 'this week':
    case 'last week':
    case 'next week':
    case 'this month':
    case 'last month':
    case 'next month':
    case 'this year':
    case 'last year':
    case 'next year':
    case 'this weeks':
    case 'last weeks':
    case 'next weeks':
    case 'this months':
    case 'last months':
    case 'next months':
    case 'this years':
    case 'last years':
    case 'next years': {
      let start = moment(today);
      let period = dateUtterance.substring(5);
      if (
        dateUtterance == 'week' ||
        dateUtterance == 'weeks' ||
        dateUtterance == 'weekly'
      ) {
        period = dateUtterance;
        relativeLast = relativeLast != null ? relativeLast : true;
      }
      period = period.replace('s', '').replace('ly', '');
      if (dateUtterance.indexOf('last') == 0 || relativeLast === true) {
        start = start.subtract(1, period);
      }
      if (dateUtterance.indexOf('next') == 0) {
        start = start.add(1, period);
      }
      let startToday = start.clone();
      start = start.startOf(period == 'week' ? 'isoWeek' : period);
      let end = start.clone().endOf(period == 'week' ? 'isoWeek' : period);
      if (period == 'week') {
        start = start.isoWeekday(relativeWeekDay + 1);
        if (start > startToday) {
          start = start.subtract(1, 'week');
        }
        end = start.clone().add(6, 'days');
      }
      return _extractDatespanCreateResponse(dates, start, end);
    }

    case 'the last week':
    case 'the last month':
    case 'the last year':
    case 'the next week':
    case 'the next month':
    case 'the next year': {
      let period = dateUtterance.substring(9);
      let end = moment(today);
      let start = end.clone().subtract(1, period);
      if (dateUtterance.indexOf('next') != -1) {
        start = moment(today);
        end = start.clone().add(1, period);
      }
      return _extractDatespanCreateResponse(dates, start, end);
    }
  }

  let nlpDate = keyDate.date;
  if (!_extractDatespanNlpDateHasData(nlpDate)) {
    let partialYearUtterance = _extractDatespanStartsWithPartialYear(
      dateUtterance
    );
    if (partialYearUtterance != null) {
      let partialYearParts = partialYearUtterance.split(' ');
      let yearUtterance =
        partialYearParts.length == 2
          ? new Number(partialYearParts[1]).valueOf()
          : null;
      let year = today.getFullYear();
      if (
        Number.isInteger(yearUtterance) &&
        yearUtterance >= 1000 &&
        yearUtterance <= 9999
      ) {
        year = yearUtterance;
      }
      switch (partialYearParts[0]) {
        case 'q1':
        case 'q2':
        case 'q3':
        case 'q4': {
          let start = moment(today)
            .year(year)
            .quarter(partialYearParts[0].substring(1))
            .startOf('quarter');
          let end = start.clone().endOf('quarter');
          return _extractDatespanCreateResponse(dates, start, end);
        }

        case 'h1':
        case 'h2': {
          let start = moment(today)
            .year(year)
            .quarter(partialYearParts[0].substring(1) == '1' ? 1 : 3)
            .startOf('quarter');
          let end = moment(today)
            .year(year)
            .quarter(partialYearParts[0].substring(1) == '1' ? 2 : 4)
            .endOf('quarter');
          return _extractDatespanCreateResponse(dates, start, end);
        }
      }
    }
    let nlpDateYearUtterance = new Number(dateUtterance).valueOf();
    if (
      Number.isInteger(nlpDateYearUtterance) &&
      nlpDateYearUtterance >= 1000 &&
      nlpDateYearUtterance <= 9999
    ) {
      nlpDate.year = nlpDateYearUtterance;
    }

    let cardinalPeriod = _extractDatespanStartsWithCardinalPeriod(
      dateUtterance
    );
    if (cardinalPeriod != null) {
      let cardinalPeriodParts = cardinalPeriod.split(' ');
      let cardinal = new Number(cardinalPeriodParts[0]).valueOf();
      let period = cardinalPeriodParts[1];
      let end = moment(today);
      let start = end.clone().subtract(cardinal, period);
      return _extractDatespanCreateResponse(dates, start, end);
    }
  }

  if (_extractDatespanNlpDateHasData(nlpDate)) {
    //if only month or only month and date defined fill in year with current year
    if (
      _extractDatespanNlpDateHasOnlyMonth(nlpDate) ||
      _extractDatespanNlpDateHasOnlyMonthAndDate(nlpDate)
    ) {
      nlpDate.year = today.getFullYear();
    }

    if (_extractDatespanNlpDateHasOnlyMonthAndYear(nlpDate)) {
      let start = moment(new Date(nlpDate.year, nlpDate.month, 1));
      let end = start.clone().endOf('month');
      return _extractDatespanCreateResponse(dates, start, end);
    }

    if (_extractDatespanNlpDateHasOnlyYear(nlpDate)) {
      let start = moment(new Date(nlpDate.year, 0, 1));
      let end = start.clone().endOf('year');
      return _extractDatespanCreateResponse(dates, start, end);
    }

    if (_extractDatespanNlpDateHasOnlyMonthAndYearAndDate(nlpDate)) {
      let start = moment(new Date(nlpDate.year, nlpDate.month, nlpDate.date));
      return _extractDatespanCreateResponse(dates, start);
    }

    if (_extractDatespanNlpDateHasOnlyWeekday(nlpDate)) {
      let start = moment(today);
      if (dateUtterance.indexOf('last') == 0) {
        start = start.subtract(1, 'week');
      }
      start = start.startOf('week').add(nlpDate.weekday, 'days');
      return _extractDatespanCreateResponse(dates, start);
    }
  }

  return _extractDatespanCreateResponse(dates);
}

function _extractDatespanStartsWithPartialYear(dateUtterance) {
  dateUtterance = dateUtterance.replace(/(q|h)(uarter|tr|alf)[ ]{0,1}/g, '$1');
  return dateUtterance.indexOf('q1') == 0 ||
    dateUtterance.indexOf('q2') == 0 ||
    dateUtterance.indexOf('q3') == 0 ||
    dateUtterance.indexOf('q4') == 0 ||
    dateUtterance.indexOf('h1') == 0 ||
    dateUtterance.indexOf('h2') == 0
    ? dateUtterance
    : null;
}

function _extractDatespanStartsWithCardinalPeriod(dateUtterance) {
  let match = dateUtterance.match(/last (\d{1,}) (month|year|day|week)s{0,1}/);
  if (match) {
    return `${match[1]} ${match[2]}`;
  }
  return null;
}

function _extractDatespanNlpDateHasData(nlpDate) {
  return (
    nlpDate.month != null ||
    nlpDate.date != null ||
    nlpDate.weekday != null ||
    nlpDate.year != null
  );
}

function _extractDatespanNlpDateHasOnlyMonth(nlpDate) {
  return (
    nlpDate.month != null &&
    nlpDate.date == null &&
    nlpDate.weekday == null &&
    nlpDate.year == null
  );
}

function _extractDatespanNlpDateHasOnlyMonthAndDate(nlpDate) {
  return (
    nlpDate.month != null &&
    nlpDate.date != null &&
    nlpDate.weekday == null &&
    nlpDate.year == null
  );
}

function _extractDatespanNlpDateHasOnlyMonthAndYear(nlpDate) {
  return (
    nlpDate.month != null &&
    nlpDate.date == null &&
    nlpDate.weekday == null &&
    nlpDate.year != null
  );
}

function _extractDatespanNlpDateHasOnlyYear(nlpDate) {
  return (
    nlpDate.month == null &&
    nlpDate.date == null &&
    nlpDate.weekday == null &&
    nlpDate.year != null
  );
}

function _extractDatespanNlpDateHasOnlyMonthAndYearAndDate(nlpDate) {
  return (
    nlpDate.month != null &&
    nlpDate.date != null &&
    nlpDate.weekday == null &&
    nlpDate.year != null
  );
}

function _extractDatespanNlpDateHasOnlyWeekday(nlpDate) {
  return (
    nlpDate.month == null &&
    nlpDate.date == null &&
    nlpDate.weekday != null &&
    nlpDate.year == null
  );
}

function _extractDatespanCreateResponse(dates, start, end) {
  if (start) {
    return {
      success: true,
      normal: dates[0].normal,
      start: start.format('YYYY-MM-DD'),
      end: (end || start).format('YYYY-MM-DD'),
    };
  }
  return { success: false };
}

export function extractDimension(nlpSentence) {
  let terms = nlpSentence.match('!#RecordsFlag').out('terms');

  let forTermIndex = terms.findIndex(
    term => term.tags.includes('DimensionPrefix') && !term.tags.includes('Drop')
  );
  forTermIndex =
    forTermIndex == -1
      ? terms.findIndex(term => term.tags.includes('DimensionPrefix'))
      : forTermIndex;
  if (forTermIndex != -1) {
    let dateTermIndex = terms.findIndex(
      (term, index) =>
        index > forTermIndex &&
        (term.tags.includes('Date') ||
          term.tags.includes('Adjective') ||
          term.tags.includes('Copula') ||
          term.tags.includes('Common') ||
          term.tags.includes('Preposition') ||
          term.tags.includes('PastTense'))
    );
    let dimensionStartTermIndex = forTermIndex + 1;
    let dimensionEndTermIndex =
      dateTermIndex == -1 ? terms.length : dateTermIndex;
    if (dimensionStartTermIndex != dimensionEndTermIndex) {
      return _extractDimensionCreateResponse(
        terms,
        dimensionStartTermIndex,
        dimensionEndTermIndex
      );
    }
  }

  let subjectPrefixIndex = terms.findIndex(term =>
    term.tags.includes('SubjectPrefix')
  );
  if (subjectPrefixIndex != -1) {
    let dateTermIndex = Array.from(terms)
      .reverse()
      .findIndex((term, index) => {
        return (
          index >= terms.length - subjectPrefixIndex &&
          (term.tags.includes('Date') ||
            term.tags.includes('Common') ||
            term.tags.includes('Infinitive') ||
            term.tags.includes('Pronoun'))
        );
      });
    let dimensionStartTermIndex =
      dateTermIndex == -1 ? 0 : terms.length - dateTermIndex + 1;
    let dimensionEndTermIndex = subjectPrefixIndex;
    if (dimensionStartTermIndex < dimensionEndTermIndex) {
      return _extractDimensionCreateResponse(
        terms,
        dimensionStartTermIndex,
        dimensionEndTermIndex
      );
    }
  }

  forTermIndex = terms.findIndex(term => term.tags.includes('VerbPhrase'));
  if (forTermIndex != -1 && forTermIndex < terms.length - 1) {
    if (
      !terms[forTermIndex + 1].tags.includes('Pronoun') &&
      !terms[forTermIndex + 1].tags.includes('Drop') &&
      !terms[forTermIndex + 1].tags.includes('Subject')
    ) {
      let dateTermIndex = terms.findIndex(
        (term, index) =>
          index > forTermIndex &&
          (term.tags.includes('Date') ||
            term.tags.includes('Adjective') ||
            term.tags.includes('VerbPhrase') ||
            term.tags.includes('Common'))
      );
      let dimensionStartTermIndex = forTermIndex + 1;
      let dimensionEndTermIndex =
        dateTermIndex == -1 ? terms.length : dateTermIndex;
      if (dimensionStartTermIndex < dimensionEndTermIndex) {
        return _extractDimensionCreateResponse(
          terms,
          dimensionStartTermIndex,
          dimensionEndTermIndex
        );
      }
    }
  }

  return _extractDimensionCreateResponse(terms);
}

function _extractDimensionCreateResponse(sentenceTerms, startIndex, endIndex) {
  if (startIndex != null) {
    let terms = sentenceTerms.slice(startIndex, endIndex);
    return { success: true, normal: terms.map(term => term.normal).join(' ') };
  }
  return { success: false };
}

export function extractUnit(nlpSentence) {
  let terms = nlpSentence.out('terms');

  let unitIndex = terms.findIndex(term => term.tags.includes('ApeUnit'));
  if (unitIndex != -1) {
    let endUnitIndex = unitIndex;
    while (
      endUnitIndex < terms.length - 1 &&
      terms[endUnitIndex + 1].tags.includes('ApeUnit')
    ) {
      endUnitIndex = endUnitIndex + 1;
    }
    let value = terms.find(
      term => term.tags.includes('Value') || term.tags.length == 0
    );
    let valueText = null;
    if (value != null) {
      valueText = value.normal;
    }
    let unitTerms = terms.slice(unitIndex, endUnitIndex + 1);
    let uom = unitTerms.map(term => term.normal).join(' ');
    return {
      success: true,
      normal: `${valueText || ''} ${uom}`.trim(),
      uom: uom,
      value: valueText,
    };
  }

  return { success: false };
}
